<template>
    <div>
        <Subtitle :subtitle='rightObj.subTitle' style="height: 14%" />
        <Echarts ref="myEchartsRight02" :parmas="rightObj.parmas" style="height: 81%;" />
    </div>
</template>

<script>
import Subtitle from '@/components/header/subTitle.vue';
import Echarts from '@/components/common/echarts';
export default {
    props: {
        rightObj: {
            typeof: Object
        }
    },
    components: {
        Subtitle,
        Echarts
    },
    data() {
        return {};
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {},
    destroyed() {},
    methods: {},
};
</script>

<style lang='scss' scoped>

</style>